import { getApiErrorMessage } from '@components/common/util/util';
import { apiAuthCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import { ServerSourceTPConfig } from '@stores/sourcesList/types';
import { CatchErr } from '@utils/types';
import { serverSourceToStore } from '../sourcesList/util';

export interface ITrackingPlan {
  id: string;
  name: string;
  version: string;
  updatedAt: string;
}

export interface ITrackingPlanStore extends ITrackingPlan {
  connectSourceToTP(sourceIds: string[], onSuccess?: () => void): Promise<void>;
}

export class TrackingPlanStore implements ITrackingPlanStore {
  id: string;

  name: string;

  updatedAt: string;

  version: string;

  private readonly rootStore: IRootStore;

  constructor(plan: ITrackingPlan, rootStore: IRootStore) {
    this.id = plan.id;
    this.name = plan.name;
    this.version = plan.version;
    this.updatedAt = plan.updatedAt;
    this.rootStore = rootStore;
  }

  async connectSourceToTP(sourceIds: string[], onSuccess?: () => void) {
    const {
      userStore: { token },
      messagesStore,
      sourcesListStore,
    } = this.rootStore;
    try {
      const response = await apiAuthCaller(token).post(`trackingPlans/${this.id}/connections`, {
        sourceIds,
      });
      const sourceConfigs = response.data;
      sourceConfigs.forEach(
        (config: { sourceId: string; trackingPlanId: string; config: ServerSourceTPConfig }) => {
          sourcesListStore.updateSourceInList(
            serverSourceToStore({
              ...sourcesListStore.sourceById(config.sourceId)!,
              dgSourceTrackingPlanConfig: config,
            }),
          );
        },
      );
      onSuccess?.();
    } catch (err: CatchErr) {
      messagesStore.showErrorMessage(
        getApiErrorMessage(err, 'Failed to link sources to tracking plan'),
      );
    }
  }
}
